module.exports = __webpack_public_path__ + "static/media/Sky-min.18255732.PNG";